import React, { Component } from "react";
import Shimmer from "react-shimmer-effect";
import CandidateShareWFServices from "./Services"

export interface CandidateStatusWFCardProps {
    candShareRequestId?: string;
}

export interface CandidateStatusWFCardState {
    data?: any;
    isDataLoaded: boolean;
}

export default class CandidateStatusWFCard extends Component<CandidateStatusWFCardProps, CandidateStatusWFCardState> {
    constructor(props) {
        super(props);
        this.state = {
            isDataLoaded: false,
        };
        this.getRejectedHistory();
    }

    getRejectedHistory = () => {
        const queryParams = `entityId eq ${this.props.candShareRequestId}`;
        CandidateShareWFServices.getRejectedHistory(queryParams).then((res: any) => {
            if (res.data.length > 0) {
                this.setState({ data: res.data[res.data.length - 1], isDataLoaded: true });
            }
            else {
                this.setState({ isDataLoaded: true });
            }
        })
    };

    render() {
        return (
            <div className="container-fluid pl-0 pr-0">
                <div className="shadow bg-white pt-2 Sequential-Flow">
                    {!this.state.isDataLoaded && (
                        <div>
                            <Shimmer key="1">
                                <div className="line dropdown-shimmer" id="line1" key="line1"></div>
                            </Shimmer>
                            <br />
                            <Shimmer key="2">
                                <div className="line dropdown-shimmer" id="line2" key="line2"></div>
                            </Shimmer>
                        </div>
                    )}
                    {this.state.data && this.state.data != undefined &&
                        <div className="col-12">
                            <div className="row mt-2 font-regular">
                                <div className="col ">
                                    <div className="row align-items-center">
                                        <div className="col-12">
                                            <div className="word-break-div"><span className="font-weight-bold">Reason: </span>{this.state.data.reason ? this.state.data.reason : "-"}</div>
                                        </div>
                                        <hr />
                                        <div className="col-12">
                                            <div className="word-break-div"><span className="font-weight-bold">Comment: </span>{this.state.data.comment ? this.state.data.comment : "-"}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </div>
                    }
                    {this.state.data === undefined && this.state.isDataLoaded && (
                        <div className="col-12">
                            <div className="row mt-2 font-regular">
                                <div className="col ">
                                    <div className="row align-items-center">
                                        <div className="col-12">
                                            <div className="word-break-div"><span className="font-weight-bold">Reason: </span>-</div>
                                        </div>
                                        <hr />
                                        <div className="col-12">
                                            <div className="word-break-div"><span className="font-weight-bold">Comment: </span>-</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
